import { EVENT_TYPE } from '../../model/events';
import RestClient from '../RestClient';

import { Container, GRAPHQL_GATEWAY_PATH, GraphQLRequest, ObjectItem } from './model';

const ACTIVITIES_LIMIT = 50;

const ACTIVITIES = `
  nodes {
    id
    timestamp
    eventType
    object {
      id
      name
      cloudID
      url
      iconURL
    }
    containers {
      name
    }
    contributors {
      profile {
        accountId
        name
        picture
      }
    }
  }
`;

const MY_ACTIVITY_QUERY = `
    query start_MyActivity($first: Int) {
      myActivities {
        workedOn(first: $first) {
          ${ACTIVITIES}
        }
        viewed(first: $first) {
          ${ACTIVITIES}
        }
      }
    }
    `;

const SEARCH_QUERY = `
    query Search($name: String!, $first: Int) {
      myActivities {
        search(name: $name, first: $first) {
          ${ACTIVITIES}
        }
      }
    }
    `;

export interface ContributorConnection {
  profile: {
    accountId: string;
    name?: string;
    picture: string;
  };
}

export interface ActivityConnectionItem {
  containers?: Container[];
  contributors?: ContributorConnection[];
  eventType: EVENT_TYPE;
  id: string;
  object: ObjectItem;
  timestamp: string;
}

export interface ActivityConnection {
  nodes?: ActivityConnectionItem[];
}

export interface ActivityTabsConnection {
  myActivities: {
    viewed: ActivityConnection;
    workedOn: ActivityConnection;
  };
}

export interface ActivityTabsSearchConnection {
  myActivities: {
    search: ActivityConnection;
  };
}

export interface ActivityDataTabsConnection {
  data?: ActivityTabsConnection;
}

class GGClient extends RestClient {
  async getMyActivities(): Promise<ActivityDataTabsConnection> {
    return this.postResource<ActivityDataTabsConnection, GraphQLRequest>(GRAPHQL_GATEWAY_PATH, {
      operationName: 'start_MyActivity',
      query: MY_ACTIVITY_QUERY,
      variables: {
        first: ACTIVITIES_LIMIT,
      },
    });
  }

  async search(name: string, limit: number): Promise<{ data: ActivityTabsSearchConnection }> {
    return this.postResource<{ data: ActivityTabsSearchConnection }, GraphQLRequest>(GRAPHQL_GATEWAY_PATH, {
      operationName: 'Search',
      query: SEARCH_QUERY,
      variables: {
        first: limit,
        name,
      },
    });
  }
}

export default new GGClient();
